package com.crowpay.views.screens.contractor

import com.crowpay.*
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.sdk.notNullSession
import com.crowpay.utils.Action
import com.crowpay.views.screens.auth.ContractorNewRegistration
import com.crowpay.views.screens.common.ProjectLens
import com.crowpay.views.screens.auth.ContractorRegistrationRouter
import com.crowpay.views.screens.common.LandingScreen
import com.crowpay.views.theming.*
import com.lightningkite.kiteui.CancelledException
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.mainScreenNavigator
import com.lightningkite.kiteui.navigation.screenNavigator
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.reactive
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.atEnd
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.expanding
import kotlinx.coroutines.launch

suspend fun ViewWriter.verifyContractor() {
    val self = notNullSession().self()
    if (self.role >= UserRole.Admin) return

    val membership = self.membership
    val selected = selectedContractor()

    when {
        membership == null -> mainScreenNavigator.reset(LandingScreen())
        membership != selected -> selectedContractor.value = membership.contractor
    }
}

interface ContractorPage : Page {
    // If null then it just shoots them back to the registration screen
    val finishRegistrationMessage: String? get() = "You need to finish registering before you can see this"
    val awaitingApprovalMessage: String
        get() =
            "Your account is currently awaiting approval. You will have limited access until approved. Once reviewed, you'll receive a notification confirming your account status."

    fun ViewWriter.renderFinishRegistration() {
        sizeConstraints(width = AppDimensions.pageWidth) - col {
            notificationBar(AppColors.yellow) - col {
//                finishRegistrationMessage?.let {
//                    body(it)
//                }
//                    ?: screenNavigator.reset(ContractorRegistrationRouter)
                atEnd - tertiaryButton - button {
                    specCenteredText("Finish Registration")
                    action = Action("Go To Registration") {
                        screenNavigator.reset(ContractorNewRegistration())
                    }
                }
            }
        }
    }

    fun ViewWriter.renderAwaitingApproval() {
        col {
            spacing = AppDimensions.majorColumnSpacing
            sizeConstraints(width = AppDimensions.pageWidth) - notificationBar(AppColors.blue) - row {
                body(awaitingApprovalMessage)
            }

            expanding - renderMainContent()
        }
    }

    fun ViewWriter.renderMainContent()

    override fun ViewWriter.render2(): ViewModifiable {
        return expanding - stack {
            spacing = 0.px
            launch { verifyContractor() }
            reactive {
                clearChildren()
                val active = contractorStatus() ?: run {
                    screenNavigator.reset(LandingScreen())
                    throw CancelledException("No Contractor")
                }
                when (active) {
                    ContractorStatus.Registering -> renderFinishRegistration()
                    ContractorStatus.AwaitingApproval -> renderAwaitingApproval()
                    ContractorStatus.Approved -> renderMainContent()
                }
            }
        }
    }
}

interface MightBeContractorPage : Page {
    val lens: ProjectLens

    // If null then it just shoots them back to the registration screen
    val finishRegistrationMessage: String? get() = "You need to finish registering before you can see this"
    val awaitingApprovalMessage: String get() = "Your account is currently awaiting approval. You will have limited access until approved."

    fun ViewWriter.renderFinishRegistration() {
        sizeConstraints(width = AppDimensions.pageWidth) - col {
            notificationBar(AppColors.yellow) - col {
                finishRegistrationMessage?.let {
                    body(it)
                } ?: screenNavigator.reset(ContractorRegistrationRouter)
                atEnd - tertiaryButton - button {
                    specCenteredText("Finish Registration")
                    action = Action("Go To Registration") {
                        screenNavigator.reset(ContractorNewRegistration())
                    }
                }
            }
        }
    }

    fun ViewWriter.renderAwaitingApproval() {
        col {
            spacing = AppDimensions.majorColumnSpacing
            sizeConstraints(width = AppDimensions.pageWidth) - notificationBar(AppColors.blue) - row {
                body(awaitingApprovalMessage)
            }

            renderMainContent()
        }
    }

    fun ViewWriter.renderMainContent(): ViewModifiable

    override fun ViewWriter.render2(): ViewModifiable =
        when (lens) {
            ProjectLens.Contractor -> {
                expanding - stack {
                    spacing = 0.px
                    launch { verifyContractor() }
                    reactive {
                        clearChildren()
                        val active = contractorStatus() ?: run {
                            screenNavigator.reset(LandingScreen())
                            throw CancelledException("No Contractor")
                        }
                        when (active) {
                            ContractorStatus.Registering -> renderFinishRegistration()
                            ContractorStatus.AwaitingApproval -> renderAwaitingApproval()
                            ContractorStatus.Approved -> renderMainContent()
                            else -> renderMainContent()
                        }
                    }
                }
            }

            ProjectLens.Customer, ProjectLens.Preview -> {
                renderMainContent()
            }
        }

}